export enum DocumentKey {
    PASSWORD = 'password',
    PINCODE = 'pin_code',
    BANKID = 'bank_id'    
}